import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const RULES_TOUR_STORAGE_KEY = "se_admin_rules_tour_seen_v1";

export const RULES_TOUR_STEPS = [
  {
    id: "custom-title",
    target: "tour-custom-title",
    title: "Add a custom title",
    body: "This title appears on the player rules page and the category page. Up to 250 characters.",
  },
  {
    id: "custom-rules",
    target: "tour-custom-rules",
    title: "Add custom rules",
    body: "Add 1 to 6 rules. Each rule can be up to 200 characters. At least one rule is required before you continue.",
  },
  {
    id: "page-content",
    target: "tour-page-content",
    title: "Page Content colors",
    body: "Text Color is used for the title; Sub Text color for the rules list and the question text on mobile. Button Color and Button Text Color style the player's Next and Home Page buttons.",
  },
  {
    id: "save",
    target: "tour-actions",
    title: "Save and continue",
    body: "Click Next to save these settings and continue to the game page image and questions.",
  },
];

export default function RulesFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={RULES_TOUR_STEPS} />;
}

export function markRulesTourSeen() {
  markTourSeen(RULES_TOUR_STORAGE_KEY);
}

export function shouldAutoStartRulesTour() {
  return shouldAutoStartTour(RULES_TOUR_STORAGE_KEY);
}
